export const formatTimeAgo = (timestamp: Date | null): string => {
  if (!timestamp) {
    return ''
  }

  const now = new Date()
  const diffMs = now.getTime() - timestamp.getTime()
  const diffSeconds = Math.floor(diffMs / 1000)
  const diffMinutes = Math.floor(diffSeconds / 60)
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)
  const diffWeeks = Math.floor(diffDays / 7)
  const diffMonths = Math.floor(diffDays / 30)
  const diffYears = Math.floor(diffDays / 365)

  const LAST_SAVED_TEXT = 'Saved'
  let timeAgoText = ''
  if (diffSeconds < 60) {
    timeAgoText = 'just now'
  } else if (diffMinutes < 60) {
    timeAgoText = `${diffMinutes}m ago`
  } else if (diffHours < 24) {
    timeAgoText = `${diffHours}h ago`
  } else if (diffDays < 7) {
    timeAgoText = `${diffDays}d ago`
  } else if (diffWeeks < 4) {
    timeAgoText = `${diffWeeks}w ago`
  } else if (diffMonths < 12) {
    timeAgoText = `${diffMonths}mo ago`
  } else {
    timeAgoText = `${diffYears}y ago`
  }

  return `${LAST_SAVED_TEXT} ${timeAgoText}`
}
